import React, { useState } from "react";

export default function ChairSamples() {
  const [items, setItems] = useState([
    { name: "آزاد", status: "free" },
    { name: "انتخاب شما", status: "mine" },
    { name: "خریداری شده", status: "sold" },
    { name: "رزرو دیگران", status: "reserved" },
    { name: "غیر قابل خرید", status: "blocked" },
  ]);
  return (
    <div
      className="row mx-auto px-0 text-center mt-3"
      style={{ maxWidth: "375px" }}
      dir="rtl"
    >
      {items.map((item, i) => (
        <div className="col px-1 text-center">
          <button
            className={`btn border-0 shadow-sm p-0 fs-7 mb-1 ${
              item.status === "sold"
                ? "bg-red text-white"
                : item.status === "reserved"
                ? "bg-warning"
                : item.status === "blocked"
                ? "bg-dark text-white"
                : item.status === "mine"
                ? "bg-light-green text-white"
                : "bg-gray"
            }`}
            style={{
              width: "18px",
              height: "18px",
              borderRadius: "5px",
              cursor: item.status === "free" ? "pointer" : "auto",
            }}
          />
          <p className="mb-0 fs-8 fw-bolder">{item.name}</p>
        </div>
      ))}
    </div>
  );
}
